import React, { ReactElement, ReactNode } from 'react';
import { Emoji, BaseEmoji, getEmojiDataFromNative } from 'emoji-mart';
import { isWindows } from 'react-device-detect';

import data from 'emoji-mart/data/apple.json';
import { css } from '@emotion/react';
const set = 'apple';

export function getEmojiFromNativeString(nativeString?: string): BaseEmoji | null {
  if (!nativeString) return null;
  return getEmojiDataFromNative(nativeString, set, data);
}

export interface EmojiProps {
  children?: ReactNode;
  decoratedText?: string;
}

export default function EmojiEntity({ children, decoratedText }: EmojiProps): ReactElement {
  const foundedEmoji = getEmojiFromNativeString(decoratedText);

  if (!isWindows) {
    return <span title={foundedEmoji?.emoticons[0]}>{children || decoratedText}</span>;
  }

  if (foundedEmoji) {
    return (
      <span
        css={css`
          .emoji-mart-emoji {
            font-size: inherit;
            & > span {
              span {
                color: transparent;
              }
            }
          }
        `}
      >
        <Emoji emoji={foundedEmoji} skin={foundedEmoji.skin || 1} size={17}>
          {children || decoratedText}
        </Emoji>
      </span>
    );
  }

  return <>{children || decoratedText}</>;
}
